import { render } from "./ProposalSearch.vue?vue&type=template&id=43a4e5e8&scoped=true"
import script from "./ProposalSearch.vue?vue&type=script&lang=js"
export * from "./ProposalSearch.vue?vue&type=script&lang=js"

import "@/assets/css/table-resp.css?vue&type=style&index=0&id=43a4e5e8&scoped=true&lang=css"
import "./ProposalSearch.vue?vue&type=style&index=1&id=43a4e5e8&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a4e5e8"]])

export default __exports__